import axios from "axios";
// eslint-disable-next-line no-undef
const API_URL = process.env.VUE_APP_API_URL;

const state = {
  logoUrl: null,
};

const mutations = {
  SET_LOGO(state, payload) {
    state.logoUrl = payload;
  },
};

const actions = {
  async fetchLogo({ commit }) {
    try {
      const response = await axios.get(`${API_URL}/spju/logo`, {
        responseType: "blob",
      });
      const url = URL.createObjectURL(response.data);
      commit("SET_LOGO", url);
    } catch (error) {
      console.error("Gagal ambil logo:", error);
      commit("SET_LOGO", null);
    }
  },

  async uploadLogo({ dispatch }, file) {
    try {
      const formData = new FormData();
      formData.append("filelogo", file); // key = filelogo

      await axios.post(`${API_URL}/spju/uploadlogo`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // setelah upload, ambil ulang logo terbaru
      dispatch("fetchLogo");
    } catch (error) {
      console.error("Gagal upload logo:", error);
      throw error;
    }
  },
};

const getters = {
  logoUrl: (state) => state.logoUrl,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
